module.exports = __webpack_public_path__ + "static/img/glasses_04.d1dd54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/glasses_04.png
// module id = t9H5
// module chunks = 0